import Vue from 'vue';
import store from './../../store';

const success = ({ data }, resolve) => {
  const siteLanguagesData = data;
  store.dispatch('fetchSiteLanguages', { siteLanguagesData });
  resolve();
};

const failed = (error, reject) => reject(error);


export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('site-language')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/siteLanguages/all.js